import { useQuery } from '@tanstack/react-query';

import { listGoogleConnections } from '@/services/google-connections/google-connections';
import { GoogleConnectionsResponse } from '@/services/google-connections/types';

export const googleConnectionsQueryKey = (orgId?: string) => [
  'google-connections',
  orgId,
];

export const useGoogleConnections = (orgId?: string) =>
  useQuery<GoogleConnectionsResponse>({
    queryKey: googleConnectionsQueryKey(orgId),
    queryFn: () => listGoogleConnections(orgId!),
    enabled: !!orgId,
    refetchOnWindowFocus: false,
    retry: 1,
  });
